import React from 'react'
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { NavLink } from 'react-router-dom';

function BecomeAPartner() {
  return (
    <div>
        <DropdownMenu.Root>
            <DropdownMenu.Trigger asChild>
                <button className="ms-5 cursor-pointer focus:outline-none text-black rounded-es-md rounded-3xl px-3 py-1">
                    Become a Partner?
                </button>
            </DropdownMenu.Trigger>

            <DropdownMenu.Content
                className="z-50 w-72 mt-3 rounded-2xl bg-[#fdf5f5] p-4 shadow-xl animate-fade-in"
                align="start"
            >
                {/* <div className="mb-3">
                    <p className="text-sm text-gray-700 mb-1">Already have an account?</p>
                    <DropdownMenu.Item asChild className="focus:outline-none focus-visible:outline-none">
                        <NavLink
                            to="/vendor-login"
                            className="block text-center w-full px-4 py-2 rounded-xl text-white bg-[#4a90e2] hover:bg-[#357abd] transition duration-300 font-semibold shadow-md"
                        >
                            Login
                        </NavLink>
                    </DropdownMenu.Item>
                </div> */}

                <div>
                    <p className="text-sm text-gray-700 mb-2">New Here?</p>
                    <DropdownMenu.Item asChild className="focus:outline-none focus-visible:outline-none">
                        <NavLink
                            to="/vendor-registration"
                            className="block text-center w-full px-4 py-2 rounded-xl text-white bg-[#4a90e2] hover:bg-[#357abd] transition duration-300 font-semibold shadow-md"
                        >
                            Sign Up
                        </NavLink>
                    </DropdownMenu.Item>
                </div>
            </DropdownMenu.Content>
        </DropdownMenu.Root>
    </div>
  )
}

export default BecomeAPartner